









import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";
import { ITurnedTextStyle, TurnedTextFormatKinds } from "../../../../../documaker/domain/format/objects";

@Component({
  components: {
    OptionDropDownSelector,
  }
})
export default class TurnedTextStyleEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ITurnedTextStyle) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITurnedTextStyle) => T, defaultValue: T) => T;
  
  get formatKind(): TurnedTextFormatKinds {
    return this.readPropertyOrDefault(s => s.formatKind, TurnedTextFormatKinds.None);
  }

  set formatKind(value: TurnedTextFormatKinds) {
    this.writePropertyWhenValid(s => s.formatKind = value);
  }

  formatKindOptions: StandardOption<number>[] = [
    new StandardOption<number>("設定しない", TurnedTextFormatKinds.None),
    new StandardOption<number>("＊", TurnedTextFormatKinds.Asterisk),
    new StandardOption<number>("●", TurnedTextFormatKinds.Dot),
  ];
}
